import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import i18n from 'i18next';
import { useTranslation } from "react-i18next";
import { Outlet, useLocation } from "react-router-dom";

import Flex from "../core/Flex";
import Space from "../core/Space";
import { basename } from "../../setting";
import useAuthAdminStore from "../../store/useAuthAdminStore";

function Sidebar() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isAdminUser } = useAuthAdminStore();

  const isApplicationListPage = window.location.pathname === `/${basename}/${i18n.language}/admin/application`;
  const isApplicationDetailPage = window.location.pathname.startsWith(`/${basename}/${i18n.language}/admin/application/`);
  const isAccountListPage = window.location.pathname.startsWith(`/${basename}/${i18n.language}/admin/account`);
  const isSettingPage = window.location.pathname.startsWith(`/${basename}/${i18n.language}/admin/setting`);

  return (
    <Flex width={"100%"} height={"100%"} gap={0} alignItems={"flex-start"}>
      <SidebarContainer>
        <SidebarContent>
          <SidebarSection>
            <Logo src={`${process.env.PUBLIC_URL}/images/icon.png`} />
            {/* <MenuItemButton>
              <MenuItemIcon src={`${process.env.PUBLIC_URL}/images/icon_house.png`} />
              <MenuItemText>Home</MenuItemText>
            </MenuItemButton> */}
            <MenuItemButton $active={isApplicationListPage || isApplicationDetailPage} href={`/${basename}/${i18n.language}/admin/application`}>
              <MenuItemIcon src={`${process.env.PUBLIC_URL}/images/icon_paper-pen.png`} />
              <MenuItemText>{t("translation:admin.request.title")}</MenuItemText>
            </MenuItemButton>
            {
              isAdminUser() &&
              <MenuItemButton $active={isAccountListPage} href={`/${basename}/${i18n.language}/admin/account`}>
                <MenuItemIcon src={`${process.env.PUBLIC_URL}/images/people-3.png`} />
                <MenuItemText>{t("translation:admin.account.title")}</MenuItemText>
              </MenuItemButton>
            }
          </SidebarSection>
          <SidebarSection>
            <MenuItemButton $active={isSettingPage} href={`/${basename}/${i18n.language}/admin/setting`}>
              <MenuItemIcon src={`${process.env.PUBLIC_URL}/images/icon_setting.png`} />
              <MenuItemText>{t("translation:admin.setting.title")}</MenuItemText>
            </MenuItemButton>
          </SidebarSection>
        </SidebarContent>
      </SidebarContainer>

      <Outlet />
    </Flex>
  );
}

const SidebarContainer = styled(Flex)`
  width: 80px;
  height: 100%;
  flex-direction: column;
  gap: 0px;
`;

const Logo = styled.img`
  width: 32px;
  height: 32px;
  margin: 17px;
`;

const SidebarContent = styled(Flex)`
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #00457a 30%, #0272ae, #01CAFA) !important;
  flex-direction: column;
  gap: 0px;
  justify-content: space-between;
`;

const SidebarSection = styled(Flex)`
  flex-direction: column;
  gap: 0px;
`;

const MenuItemButton = styled.a`
  border: none;
  background-color: transparent;
  cursor: pointer;
  width: 80px;
  height: 80px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  line-height: 18px;
  text-decoration: none;
  ${(props) => props.$active && `
    background-color: var(--aia-bx-blue-1);
  `}

  &:hover {
    background-color: var(--aia-bx-blue-1);
  }
`;

const MenuItemIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const MenuItemText = styled.div`

`;

export default Sidebar;